import { createContext, useCallback, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

export const NotificationContext = createContext(null);

/**
 * Provides a global toast notification system.
 * Wrap the app in this provider, then use the useNotification hook
 * to call notifySuccess / notifyError from any component.
 */
const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const notifySuccess = useCallback((message) => {
    setNotification({ open: true, message, severity: "success" });
  }, []);

  const notifyError = useCallback((message) => {
    setNotification({ open: true, message, severity: "error" });
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setNotification((prev) => ({ ...prev, open: false }));
  };

  return (
    <NotificationContext.Provider value={{ notifySuccess, notifyError }}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={notification.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
